import { Theme, StyleRules } from '@material-ui/core/styles';

export default (theme: Theme): StyleRules => ({
    mapWrapper: {
        width: '100%',
        height: '100%',
        position: 'relative',
    },
    mapWrapperFixed: {
        position: 'fixed',
        width: '50%',
        height: '80vh',
    },
    towerName: {
        flex: 1,
        marginLeft: theme.spacing(2),
    },
    towerActions: {
        display: 'flex',
        gap: theme.spacing(1),
    },
});
